import { KycService, InitService } from "@/services";
import * as types from "@/store/types";
import { mapGetters, mapActions } from "vuex";

const noWebcam = () =>
  import(
    /* webpackChunkName: "noWebcam" */ "@/components/AccountPage/Kyc/NoWebcam/index"
  );
export default {
  name: "video-guid",
  data() {
    return {
      isModalOpen: false,
      isVideoRecord: false,
      showPreview: false,
      videoData: null,
      value: 0,
      interval: {},
      isuploadModalOpen: false,
      uploadValue: 0,
      userCanRecord: false,
      uploadPercentage: 0
    };
  },
  components: {
    noWebcam
  },
  computed: {
    ...mapGetters({
      initData: types.init.getters.GET_INIT_DATA
    })
  },
  methods: {
    ...mapActions({
      setInit: types.init.actions.SET_INIT_DATA
    }),
    async openCreateVideoModal() {
      this.isModalOpen = true;
      this.getInit();
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            height: 962,
            width: 540
          },
          audio: true
        });
        if (stream.active) this.userCanRecord = true;
      } catch (e) {
        if (e) {
          this.isModalOpen = false;
          this.$refs.noWebcam.openModal();
        }
      }
    },

    getInit() {
      InitService.init().then(res => {
        this.setInit(res.data.data);
      });
    },
    closeVideoModal() {
      this.isModalOpen = false;
    },
    async record() {
      const video = document.getElementById("preview");
      const recorded = document.getElementById("recorded");
      const stopbutton = document.getElementById("stop-record");
      const startButton = document.getElementById("start-record");
      const videoRecordContainer = document.getElementById(
        "recorded-container"
      );
      const actionButtons = document.getElementById("action-button-container");
      const retakeBtn = document.getElementById("retake");
      const closeVideoModal = document.getElementById("closeVideoModal");
      recorded.style.display = "none";

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          height: 962,
          width: 540
        },
        audio: true
      });
      video.srcObject = stream;
      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: "video/webm;codecs=vp8,opus",
        videoBitsPerSecond: 2500000
      });

      mediaRecorder.width = 200;
      mediaRecorder.height = 600;
      mediaRecorder.start();
      this.interval = setInterval(() => {
        if (this.value >= 100) {
          clearInterval(this.interval);
          mediaRecorder.stop();
          video.style.display = "none";
          recorded.style.display = "block";
          videoRecordContainer.style.display = "block";
          this.isVideoRecord = false;
          this.showPreview = true;
          actionButtons.style.display = "block";
        } else {
          this.value += 100 / this.initData.kyc.video.maximum_file_length;
        }
      }, 1000);

      startButton.style.display = "none";
      stopbutton.style.display = "block";
      this.isVideoRecord = true;

      stopbutton.addEventListener("click", () => {
        mediaRecorder.stop();
        stream.getTracks().forEach(track => {
          track.stop();
        });
        clearInterval(this.interval);
        video.style.display = "none";
        recorded.style.display = "block";
        videoRecordContainer.style.display = "block";
        this.isVideoRecord = false;
        this.showPreview = true;
        actionButtons.style.display = "block";
      });
      mediaRecorder.addEventListener("dataavailable", event => {
        recorded.src = URL.createObjectURL(event.data);
        this.videoData = event.data;
        stopbutton.style.display = "none";
      });
      retakeBtn.addEventListener("click", () => {
        this.isModalOpen = false;
        video.srcObject = null;
        video.style.display = "block";
        recorded.style.display = "none";
        recorded.src = "";
        startButton.style.display = "block";
        actionButtons.style.display = "none";
        videoRecordContainer.style.display = "none";
        this.value = 0;
      });
      closeVideoModal.addEventListener("click", () => {
        video.srcObject = null;
        video.style.display = "block";
        recorded.style.display = "none";
        recorded.src = "";
        startButton.style.display = "block";
        actionButtons.style.display = "none";
        videoRecordContainer.style.display = "none";
        this.value = 0;
        mediaRecorder.stop();
        clearInterval(this.interval);
        this.isVideoRecord = false;
      });
    },
    playPreview() {
      const videoRecord = document.getElementById("play-video");
      const recorded = document.getElementById("recorded");
      videoRecord.style.display = "none";
      recorded.play();
    },
    continueUpload() {
      this.isuploadModalOpen = true;
      KycService.uploadKycVideo(this.videoData, event => {
        this.uploadValue = Math.floor((event.loaded * 100) / event.total);
        this.uploadPercentage = Math.floor((event.loaded * 100) / event.total);
      })
        .then(() => {
          this.isuploadModalOpen = false;
          this.$router.push({ name: "kycResult" });
        })
        .catch(e => {
          console.log(e);
        });
    },
    close() {
      const video = document.getElementById("preview");
      const recorded = document.getElementById("recorded");
      const startButton = document.getElementById("start-record");
      const videoRecordContainer = document.getElementById(
        "recorded-container"
      );
      const actionButtons = document.getElementById("action-button-container");
      const stopbutton = document.getElementById("stop-record");
      this.isModalOpen = false;
      video.srcObject = null;
      video.style.display = "block";
      recorded.style.display = "none";
      recorded.src = "";
      startButton.style.display = "block";
      actionButtons.style.display = "none";
      videoRecordContainer.style.display = "none";
      stopbutton.style.display = "none";
      this.value = 0;
    },
    closeUploadModal() {
      this.isuploadModalOpen = false;
    }
  }
};
